/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import SimpleTooltip from '../../../simple-tooltip';
import { ToolbarButtonProps } from './ToolbarButton';

 const ToolbarStatusSpan = (props: ToolbarButtonProps) => {
  const { contents, tooltip, onClick, onMouseOver, btnClass } = props;
  return <SimpleTooltip text={tooltip} className='tooltip-span'>
    <span
      className={`${btnClass} item-container`}
      onMouseOver={onMouseOver ? onMouseOver : () => { }}
      onClick={onClick ? onClick : () => { }}>
      {contents}
    </span>
  </SimpleTooltip>
 }

export default ToolbarStatusSpan;
